import type { PurchaseAdmin, PurchaseAdminResponse } from '../types';

const DEFAULT_CURRENCY = 'USD';

export function mapPurchaseAdmin(data: PurchaseAdminResponse): PurchaseAdmin {
  return {
    id: data.id,
    user: data.user ? { id: data.user.id, name: data.user.name, email: data.user.email } : null,
    product: data.product
      ? {
          id: data.product.id,
          name: data.product.description ?? '',
          sku: data.product.sku ?? '',
          type: data.product.type ?? '',
        }
      : null,
    amount: data.amount ?? 0,
    currency: data.currency || DEFAULT_CURRENCY,
    status: data.status ?? '',
    refunded: data.refunded,
    store: data.store ?? '',
    createdAt: data.created_at,
  };
}
